import React from "react"
import { isBlank } from "@/utils"
import { MutedcheckMark } from "@/components/Icons"
import {
  calculateTotalMaximumCapacity,
  RenderDeparturesColumn,
  RenderIssuesColumn,
} from "./Helpers"

const hasClosedDayRequest = (issues) => issues?.some((obj) => obj.kind === "day_expected_open")
const hasOpenDayRequest = (issues) => issues?.some((obj) => obj.kind === "day_expected_closed")
const isTourClosed = (closedDay) => closedDay && !closedDay.discardedAt

const TableRow = ({ call }) =>
  call.tours.map((tour, index) => {
    const isFirstTour = index === 0
    const closedDayRequest = hasClosedDayRequest(tour.issues)
    const openDayRequest = hasOpenDayRequest(tour.issues)
    const closedTour = isTourClosed(tour.closedDay)
    const isClosedDay = closedTour && !openDayRequest
    const displayTotalCapacity = !(isClosedDay || closedDayRequest) && !isBlank(tour.departures)
    const displayDepartures = isClosedDay || closedDayRequest || !isBlank(tour.departures)

    return (
      <tr key={tour.code}>
        {/* Display ship details only once, inline with the first departure */}
        {isFirstTour ? (
          <>
            <td />
            <td style={{ color: "#888888" }}>
              {`${call.ship.name}`} <br />
              {`day ${call.portDay.cruiseDay} of ${call.portDay.cruiseLength} `}
            </td>
            <td style={{ color: "#888888" }}>
              {call.ship.arrivalTime && call.ship.departureTime
                ? `${call.ship.arrivalTime} - ${call.ship.departureTime}`
                : call.ship.arrivalTime
                  ? `${call.ship.arrivalTime} - in port`
                  : call.ship.departureTime
                    ? ` in port - ${call.ship.departureTime}`
                    : "in port"}
            </td>
          </>
        ) : (
          <>
            <td />
            <td />
            <td />
          </>
        )}

        {/* Capacity Requirements */}
        <td style={{ color: "#888888" }}>
          <strong>{tour.code}</strong> <br />
          {isBlank(tour.constraints.allotmentConstraint) ||
          (isBlank(tour.constraints.allotmentConstraint.capacityPerDepartureMin) &&
            isBlank(tour.constraints.allotmentConstraint.capacityPerDepartureMax) &&
            isBlank(tour.constraints.allotmentConstraint.capacityPerDayMax)) ? (
            <div>
              No requirement
              <br /> loaded
            </div>
          ) : (
            <>
              {!isBlank(tour.constraints.allotmentConstraint.capacityPerDepartureMin) && (
                <span>
                  Min per departure:{" "}
                  {`${tour.constraints.allotmentConstraint.capacityPerDepartureMin}`}
                  <br />
                </span>
              )}
              {!isBlank(tour.constraints.allotmentConstraint.capacityPerDepartureMax) && (
                <>
                  <span className="me-1">Max per departure:</span>
                  <span>{tour.constraints.allotmentConstraint.capacityPerDepartureMax}</span>
                  <br />
                </>
              )}
              {!isBlank(tour.constraints.allotmentConstraint.capacityPerDayMax) && (
                <>
                  <span className="me-1">Max per day:</span>
                  <span>{tour.constraints.allotmentConstraint.capacityPerDayMax}</span>
                </>
              )}
            </>
          )}
        </td>

        {/* Departures: time, duration & minimum */}
        {["departureTime", "durationInMinutes", "minimumCapacity"].map((property) => (
          <td key={property} style={{ color: "#888888" }}>
            {displayDepartures && (
              <RenderDeparturesColumn
                departures={tour.departures}
                property={property}
                closed={isClosedDay || closedDayRequest}
                additionalData
              />
            )}
          </td>
        ))}

        {/* Departures: Maximums & Total Capacity */}
        <td style={{ color: "#888888" }}>
          {displayDepartures && (
            <RenderDeparturesColumn
              departures={tour.departures}
              property="maximumCapacity"
              closed={isClosedDay || closedDayRequest}
              additionalData
            />
          )}
          {displayTotalCapacity && (
            <strong>{`${calculateTotalMaximumCapacity(tour.departures)} (Total)`}</strong>
          )}
        </td>

        {/* Issues & State */}
        <td style={{ color: "#888888" }}>
          {!isBlank(tour.issues) && <RenderIssuesColumn issues={tour.issues} />}
        </td>
        <td style={{ color: "#888888" }}>
          {tour.state === "Approved" && <MutedcheckMark />} {tour.state}
        </td>
        <td />
        <td />
        <td />
      </tr>
    )
  })

const AdditionalShips = ({ additionalInventoryInPort }) => {
  if (isBlank(additionalInventoryInPort)) {
    return null
  }

  return additionalInventoryInPort.map((inventory) => (
    <React.Fragment key={inventory.ship.name}>
      <TableRow call={inventory} />
    </React.Fragment>
  ))
}

export default AdditionalShips
